export interface GeoHint { country: string | null; language: string | null }
let cached: { at: number; value: Promise<GeoHint> } | undefined;

/** Survives query-cache resets during anonymous auth hydration. */
export function loadGeoHint(): Promise<GeoHint> {
  if (cached && Date.now() - cached.at < 60 * 60_000) return cached.value;
  const value = fetch(`${import.meta.env.BASE_URL || "/"}api/geo/hint`)
    .then(async response => response.ok ? await response.json() as GeoHint : { country: null, language: null })
    .catch(() => ({ country: null, language: null }));
  cached = { at: Date.now(), value };
  return value;
}
